import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import common, {
  closeLoading,
  isMobileScreen,
  showLoading,
  setPageTitle,
} from "../common";
import ShopNavigationPanel from "./extra/ShopNavigationPanel";

function Brands() {
  setPageTitle("Shop by Brand | Premium Hemp & Kratom Brands");

  return (
    <>
      <section
        className="breadcrumbs-custom"
        data-preset='{"title":"Breadcrumbs","category":"header","reload":false,"id":"breadcrumbs"}'
      >
        <div className="breadcrumbs-custom-container">
          <ul className="breadcrumbs-custom-path">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a>Brands</a>
            </li>
          </ul>
        </div>
      </section>
      <section
        className={isMobileScreen() ? "bg-white" : "section-sm bg-white"}
      >
        <div className="container-xl">
          <div className="row row-40">
            {isMobileScreen() ? (
              <></>
            ) : (
              <div className="col-md-2">
                <ShopNavigationPanel />
              </div>
            )}
            <div className="col-md-10">
              <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 g-4">
                {[
                  {
                    name: "Opia",
                    url: "/products?brand=OPIA",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/opia.png",
                  },
                  {
                    name: "Press'd",
                    url: "/products?brand=PRESS'D",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/pressd.png",
                  },
                  {
                    name: "Feel Free",
                    url: "/products?brand=Feel Free",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/feel-free.jpg",
                  },
                  {
                    name: "Polka Dot",
                    url: "/products?brand=POLKA DOT",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/polka-dot.png",
                  },
                  {
                    name: "Hollyweed",
                    url: "/products?brand=hollyweed",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/hollyweed.png",
                  },
                  {
                    name: "Tre House",
                    url: "/products?brand=Tre House",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/trehouse.png",
                  },
                  {
                    name: "Double Stacked",
                    url: "/products?brand=Double Stacked",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/double-stacked.jpg",
                  },
                  {
                    name: "Muha Meds",
                    url: "/products?brand=Muha Meds",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/muhameds.jpeg",
                  },
                  {
                    name: "Soma",
                    url: "/products?brand=Soma",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/soma.png",
                  },
                  {
                    name: "EDP",
                    url: "/products?brand=EDP",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/edp.png",
                  },
                  {
                    name: "Kalibloom",
                    url: "/products?brand=Kalibloom",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/kalibloom.png",
                  },
                  {
                    name: "OPMS",
                    url: "/products?brand=OPMS",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/opms.jpeg",
                  },
                  {
                    name: "Whole herbs",
                    url: "/products?brand=Whole herbs",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/whole-herbs.png",
                  },
                  {
                    name: "Hazy Mary",
                    url: "/products?brand=Hazy Mary",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/hazy-mary.png",
                  },
                  {
                    name: "Silly Farms",
                    url: "/products?brand=Silly Farms",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/silly-farms.webp",
                  },
                  {
                    name: "Truemoola",
                    url: "/products?brand=Truemoola",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/truemoola.png",
                  },
                  {
                    name: "Eat OHMZ",
                    url: "/products?brand=Eat OHMZ",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/eat-ohmz.jpg",
                  },
                  {
                    name: "Straight Heat",
                    url: "/products?brand=HEAT",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/straight-heat.png",
                  },
                  {
                    name: "Kama",
                    url: "/products?brand=Kama",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/kama.jpg",
                  },
                  {
                    name: "7 O'Heaven",
                    url: "/products?brand=7 O HEAVEN",
                    image:
                      "https://star-distributors.s3.us-east-1.amazonaws.com/prod-common/brand-logos/7oheaven.png",
                  },
                ].map((brand, idx) => (
                  <div className="col text-center mb-4" key={idx}>
                    <a
                      href={brand.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div className="card h-100 border-0 shadow-sm align-items-center justify-content-center p-2">
                        <img
                          src={brand.image}
                          alt={brand.name + " logo"}
                          style={{
                            width: 150,
                            height: 150,
                            objectFit: "contain",
                            margin: "0 auto",
                          }}
                          loading="lazy"
                        />
                        <div className="mt-2 fw-bold" style={{ fontSize: 14 }}>
                          {brand.name}
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Brands;
